export default __webpack_public_path__ + "static/media/apostar_icons_white_apotheke_anlegen.d85de738.svg";